import { Button } from '../../../../../components/Toolkit/Button/Button';
import { type RevealPhoneNumberProps } from '../../../../../components/PageWrappers/SharedComponents/RevealPhoneNumber/RevealPhoneNumber';
import { Columns } from '../../../../../components/Toolkit/Columns/Columns';
import { ButtonLink } from '../../../../../components/Toolkit/Button/ButtonLink';
import { DisplayContainer } from '../../../../../components/Support/DisplayContainer/DisplayContainer';
import { StickyFooterCtas } from './ctaVariants/StickyFooterCtas';
import { type EmailDealerOrSellerProps } from '../EmailDealerOrSeller/EmailDealerOrSeller.typed';
import getConfig from 'next/config';

import * as Styled from './UserActionsStickyFooter.styled';

type UserActionsStickyFooterProps = Omit<
  {
    phoneResponse: boolean;
    sectionName?: string;
    emailResponse: boolean;
    whatsappResponse: boolean;
    isViewingOwnAd?: boolean;
    editAdHref: string;
    handleBoost: () => Promise<void>;
    active: boolean;
    priceEuro?: number | null;
  } & EmailDealerOrSellerProps &
    RevealPhoneNumberProps,
  'dealerID' | 'clickSource'
>;

const UserActionsStickyFooter = (props: UserActionsStickyFooterProps) => {
  const {
    adId,
    emailResponse,
    phoneResponse,
    campaignId,
    sectionName,
    sellerType,
    whatsappResponse,
    handleReveal,
    isViewingOwnAd,
    editAdHref,
    handleBoost,
    active,
    priceEuro,
    price,
  } = props;
  const {
    publicRuntimeConfig: { FEATURE_ADP_STICKY_CTA_ALWAYS_VISIBLE },
  } = getConfig();

  const CLICK_SOURCE = 'mobile-sticky';

  const phoneContactProps: RevealPhoneNumberProps = {
    adId,
    clickSource: CLICK_SOURCE,
    isPrimaryButton: !emailResponse,
    campaignId,
    showNumberTextVariant: true,
    sectionName,
    sellerType,
    id: 'phone-number-button-footer',
    price,
  };

  const emailSellerProps: EmailDealerOrSellerProps = {
    adId,
    clickSource: CLICK_SOURCE,
    dealerID: 'dealer-enquiry-btn-footer',
    handleReveal,
    sellerType,
  };

  return (
    <Styled.MobileAndTabletStickyFooter
      position="fixed"
      active={FEATURE_ADP_STICKY_CTA_ALWAYS_VISIBLE ? true : active}
      data-testid="mobile-sticky-cta"
    >
      {isViewingOwnAd ? (
        <Columns>
          <Button onClick={handleBoost} data-testid="boost-button">
            Boost
          </Button>
          <ButtonLink href={editAdHref} ofType="SECONDARY">
            Edit
          </ButtonLink>
        </Columns>
      ) : (
        <DisplayContainer
          config={{ small: 'block', medium: 'block', large: 'none' }}
        >
          <StickyFooterCtas
            phoneResponse={phoneResponse}
            phoneContactProps={{
              ...phoneContactProps,
              isPrimaryButton: true,
            }}
            emailResponse={emailResponse}
            emailSellerProps={emailSellerProps}
            whatsappResponse={whatsappResponse}
            adId={adId}
            priceEuro={priceEuro}
            sellerType={sellerType}
            sectionName={sectionName}
            price={price}
          />
        </DisplayContainer>
      )}
    </Styled.MobileAndTabletStickyFooter>
  );
};

export { UserActionsStickyFooter, type UserActionsStickyFooterProps };
